/* ============================================
   copperMaison — Main JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {
  initAnnouncementBar();
  initHeader();
  initMobileMenu();
  initAccordion();
  initProductGallery();
  initScrollAnimations();
  initStickyATC();
  initImageZoom();
});

/* --- Announcement Bar --- */
function initAnnouncementBar() {
  const bar = document.querySelector('.announcement-bar');
  const closeBtn = document.querySelector('.announcement-bar__close');
  if (!bar || !closeBtn) return;

  closeBtn.addEventListener('click', () => {
    bar.classList.add('is-hidden');
    document.body.style.setProperty('--announcement-offset', '0px');
  });

  // Dynamic slide rotation
  const slides = bar.querySelectorAll('.announcement-bar__slide');
  if (slides.length <= 1) return;

  let current = 0;
  setInterval(() => {
    slides[current].classList.remove('is-active');
    slides[current].style.transform = 'translateY(-100%)';
    slides[current].style.opacity = '0';

    current = (current + 1) % slides.length;

    // Reset incoming slide position
    slides[current].style.transform = 'translateY(100%)';
    slides[current].style.opacity = '0';

    // Force reflow then animate in
    void slides[current].offsetWidth;
    slides[current].classList.add('is-active');
    slides[current].style.transform = 'translateY(0)';
    slides[current].style.opacity = '1';
  }, 4000);
}

/* --- Header Scroll Effect --- */
function initHeader() {
  const header = document.querySelector('.header');
  if (!header) return;

  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll > 50) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    lastScroll = currentScroll;
  }, { passive: true });
}

/* --- Mobile Menu --- */
function initMobileMenu() {
  const toggle = document.querySelector('.header__menu-toggle');
  const menu = document.querySelector('.mobile-menu');
  const close = document.querySelector('.mobile-menu__close');
  const overlay = document.querySelector('.mobile-menu__overlay');

  if (!toggle || !menu) return;

  toggle.addEventListener('click', () => {
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  });

  const closeMenu = () => {
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  };

  if (close) close.addEventListener('click', closeMenu);
  if (overlay) overlay.addEventListener('click', closeMenu);
}

/* --- Cart Drawer --- handled by cart.js */

/* --- Accordion --- */
function initAccordion() {
  document.querySelectorAll('.accordion__header').forEach(header => {
    header.addEventListener('click', () => {
      const item = header.parentElement;
      const isOpen = item.classList.contains('is-open');

      // Close all other items in the same accordion
      const accordion = item.parentElement;
      accordion.querySelectorAll('.accordion__item').forEach(i => {
        i.classList.remove('is-open');
      });

      if (!isOpen) {
        item.classList.add('is-open');
      }
    });
  });
}

/* --- Quantity Selector --- handled by cart.js */

/* --- Product Gallery --- */
function initProductGallery() {
  const mainImage = document.querySelector('.product-gallery__main img');
  const thumbs = document.querySelectorAll('.product-gallery__thumb');

  if (!mainImage || thumbs.length === 0) return;

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      // Update main image
      const newSrc = thumb.querySelector('img').src;
      mainImage.src = newSrc;

      // Update active state
      thumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
}

/* --- Scroll Animations (Premium) --- */
function initScrollAnimations() {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.08,
    rootMargin: '0px 0px -60px 0px'
  });

  // Observe all revealable elements
  document.querySelectorAll('.animate-on-scroll, .reveal, .reveal-scale, .collection-card, .product-card, .testimonial, .guarantee__item').forEach(el => {
    if (!el.classList.contains('reveal') && !el.classList.contains('reveal-scale')) {
      el.classList.add('reveal');
    }
    observer.observe(el);
  });

  // Parallax effect for quote section
  const parallaxBg = document.querySelector('.parallax-quote__bg');
  if (parallaxBg) {
    window.addEventListener('scroll', () => {
      const section = parallaxBg.closest('.parallax-quote');
      const rect = section.getBoundingClientRect();
      const windowH = window.innerHeight;
      if (rect.top < windowH && rect.bottom > 0) {
        const progress = (windowH - rect.top) / (windowH + rect.height);
        const translate = (progress - 0.5) * 40;
        parallaxBg.style.transform = `translateY(${translate}px)`;
      }
    }, { passive: true });
  }
}

/* --- Welcome Popup --- REMOVED BY USER REQUEST */

/* --- Sticky ATC Bar --- */
function initStickyATC() {
  const stickyBar = document.getElementById('sticky-atc');
  const addToCartBtn = document.getElementById('add-to-cart');
  if (!stickyBar || !addToCartBtn) return;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('is-visible');
      } else {
        stickyBar.classList.add('is-visible');
      }
    });
  }, { threshold: 0 });

  observer.observe(addToCartBtn);
}

/* --- Image Zoom on Hover --- */
function initImageZoom() {
  const zoomContainer = document.getElementById('product-zoom');
  if (!zoomContainer) return;
  const img = zoomContainer.querySelector('img');
  if (!img) return;

  zoomContainer.addEventListener('mousemove', (e) => {
    const rect = zoomContainer.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    img.style.transformOrigin = `${x}% ${y}%`;
  });

  zoomContainer.addEventListener('mouseleave', () => {
    img.style.transformOrigin = 'center center';
  });
}
